import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import DoubleCTA from '../../components/DoubleCTA/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { FlexContainer } from '../../styles/defaults'
import { Description, ServicePackage } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import employee from '../../assets/cta/employee.png'
import cta from '../../assets/cta/double-cta.jpg'

class Packages extends Component {
  render() {
    let packages = [
      {
        title: 'Ontzorg',
        bulletpoints: [
          'Kaars Koffie zorgt ervoor dat er altijd voldoende ingrediënten bij u aanwezig zijn.',
          'Samen met u stellen wij een assortimentskeuze samen, waarop alle artikelen staan die u wilt.',
          'We schatten samen in wat het verbruik zal zijn. Later bepalen we het werkelijke verbruik.',
          'Kaars Koffie komt periodiek bij u langs om de voorraadkast aan te vullen. U heeft hier geen omkijken naar.'
        ]
      },
      {
        title: 'Ondersteun',
        bulletpoints: [
          'Kaars Koffie helpt u online of telefonisch met het bestellen van de ingrediënten.',
          'Samen met u stellen wij een assortimentskeuze samen, waarop alle artikelen staan die u wilt.',
          'We schatten samen in wat het verbruik zal zijn. Later bepalen we het werkelijke verbruik.',
          'Kaars Koffie stuurt u periodiek een e-mail met daarin de assortimentskeuze en het (verwachte) verbruik. U kunt de bestelling naar wens aanpassen. Als u de order bevestigt, dan zal de levering worden ingepland.'
        ]
      },
      {
        title: 'Flexibel',
        bulletpoints: [
          'Kaars Koffie zorgt ervoor dat er altijd voldoende ingrediënten bij u aanwezig zijn.',
          'Samen met u stellen wij een assortimentskeuze samen, waarop alle artikelen staan die u wilt.',
          'Ook kunt u via ons klantportaal zelf kiezen uit het assortiment en orders plaatsen.',
          'Uw geplaatste bestelling bezorgen wij altijd binnen de met u afgesproken tijd.'
        ]
      },
    ]
    
    const { content, branch } = this.props
    return (
      <Fragment>
        <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title={content.header} />
        <Breadcrumb title="Servicepakketten" />
        <Description>Hier vindt u onze servicepakketten. U heeft momenteel het servicepakket <strong>{branch.servicePackage}</strong>.<br />Heeft u vragen of wilt u meer weten over onze servicebeloftes? Neem dan <Link to={'/contact'}>contact</Link> met ons op.<br />Of <a href="https://kaarskoffie.nl/wp-content/uploads/2019/02/3127-Kaars-Optie-Service-pakketten-Logistiek_Digitaal.pdf" target="_blank" rel="noopener noreferrer">download</a> onze leaflet.</Description>
        <FlexContainer full mt mb>
          {packages.map((servicePackage, index) => {
            return (
              <ServicePackage key={index} className={servicePackage.title === branch.servicePackage ? 'active' : ''}>
                <h3>{servicePackage.title}</h3>
                <ul>
                  {servicePackage.bulletpoints.map((bulletpoint, index) => {
                    return <li key={index}>{bulletpoint}</li>
                  })}
                </ul>
              </ServicePackage>
            )
          })}
        </FlexContainer>
        <DoubleCTA
          content={[
            {
              title: 'Vragen?',
              subtitle: 'We helpen u graag',
              employee: true,
              image: employee,
              link: {
                content: 'Contact',
                url: '/contact',
                target: ''
              }
            },
            {
              title: 'Wilt u wisselen van service?',
              image: cta,
              link: {
                content: 'Afspraak maken',
                url: 'https://kaarskoffie.nl/afspraak-maken',
                target: '_blank'
              }
            }
          ]}
        />
      </Fragment>
    )
  }
}

export default withHeaderFooter(Packages)



// WEBPACK FOOTER //
// ./src/views/Packages/index.js